import { ReactComponent as LogoIcon } from '@src/assets/icons/logo.svg';
import { Sidebar as SidebarComponent } from '@src/components';
import { useSidebar } from './hooks';
import { useTheme } from '@src/theme';

type SideBarProps = {
    isMobile?: boolean;
    onSelect?: () => void;
};

export function SideBar({
    isMobile = false,
    onSelect,
}: Readonly<SideBarProps>) {
    const { sidebarItems, selectedItem, openKeys, setSelectedItem } =
        useSidebar();

    const { theme } = useTheme();
    const logoUrl = theme.logoUrl;
    return (
        <div className="h-full w-auto transition-all duration-300">
            <SidebarComponent
                className="h-full rounded-lg"
                logo={
                    logoUrl ? (
                        <img src={logoUrl} alt="Logo" width={55} height={48} />
                    ) : (
                        <LogoIcon width={55} height={48} />
                    )
                }
                items={sidebarItems}
                collapsible={false}
                collapsed={isMobile ? false : undefined}
                selectedKey={selectedItem}
                openKeys={openKeys}
                onSelect={(value) => {
                    setSelectedItem(value);
                    onSelect?.();
                }}
            />
        </div>
    );
}
